import { useState } from "react"
import { BillingAddress } from "../../../types/payment"
import BillingAddressForm from "../../../common/ui/payment-management/billing-address-form"
import BillingAddressDisplay from "./billing-address-display"
import { Button } from "../../../common/ui/buttons"

interface BillingAddressSectionProps {
  address: BillingAddress
  orgId: string
  onUpdate: () => void
}

const BillingAddressSection = ({
  address,
  orgId,
  onUpdate
}: BillingAddressSectionProps) => {
  const [showEditAddress, setShowEditAddress] = useState(false)

  return (
    <div className="pt-12">
      <div className="flex justify-between items-center pb-4 border-b border-neutral-200">
        <h2 className="text-lg font-bold">Billing Address</h2>
        {!showEditAddress && (
          <Button className="border-0" onClick={() => setShowEditAddress(true)}>
            <div className="font-bold text-primary-500">Edit</div>
          </Button>
        )}
      </div>
      <div className="pt-6">
        {showEditAddress ? (
          <BillingAddressForm
            initialValues={address}
            orgId={orgId}
            onSuccess={() => {
              setShowEditAddress(false)
              onUpdate()
            }}
            onCancel={() => setShowEditAddress(false)}
          />
        ) : (
          <BillingAddressDisplay address={address} />
        )}
      </div>
    </div>
  )
}

export default BillingAddressSection
